/** Public beta-access endpoints. Production nginx on artistnav.com exposes only exact
 * /auth/beta/* locations (no /api); the Vite DEV server proxies only /api. */
export const BETA_API = import.meta.env.DEV ? "/api/auth/beta" : "/auth/beta";

/** Option values mirror the server-side checks in agents/app/routers/beta_launch.py. */
export const INDUSTRY_ROLES: [string, string][] = [
  ["performing_artist", "Performing artist"],
  ["band_member", "Band member"],
  ["manager", "Artist manager"],
  ["booking_agent", "Booking agent"],
  ["venue", "Venue owner / operator"],
  ["promoter", "Promoter / talent buyer"],
  ["other", "Other"],
];
export const SHOWS_PER_MONTH = ["0-1", "2-4", "5-8", "9-15", "16+"];
export const INTERESTS: [string, string][] = [
  ["venues", "Finding venues"],
  ["comparables", "Discovering comparable artists"],
  ["bookings", "Managing bookings"],
  ["shows", "Organizing shows"],
  ["relationships", "Building industry relationships"],
];
